import { useEffect } from 'react';
import { GetServerSideProps } from 'next';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import ShareCompoment from '@/components/Referral/Share';
import { ReferralProvider } from '@/components/Referral/ReferralProvider';
import SEOlinksA from '@/components/SEOlinksA';
import { getLocalStorage } from '@/utils/localStorage';
import efBridge from '@/utils/JSBridge';
import { onLogin } from '@/utils/cookie';
import CountDown from '@/components/Referral/Common/CountDown';
import { getAppSession } from '@/utils/appGetToken';

type ReferralProp = {
    SEO?: any;
};

const Referral: React.FC<ReferralProp> = ({ SEO }) => {
    const { useLang, useRouter, isApp } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('referral');

    const initInfo = () => {
        efBridge.init();
        // 设置app导航
        efBridge?.callHandler('setPageConfig', {
            showNav: 1, // 显示导航栏
            topStartFrom: 0, // 在导航栏以下显示H5
            navigationBarBackgroundColor: '#000', //设置背景色
            navigationBarTextColor: '#FFFFFF', // 设置导航栏字体色,
        });
        if (isApp) {
            // efBridge.registerHandler('getAppMsg', (res) => {
            //     if (!res) return;
            //     const dataSet = {
            //         token: res.token.replace('Bearer ', ''),
            //         user: {},
            //     };
            //     onLogin(dataSet);
            // });
            const token = getAppSession();
            const dataSet = {
                token,
                user: {},
            };
            onLogin(dataSet);
        }
    };

    useEffect(() => {
        console.log(t('seo.title'));
        initInfo();
    }, []);

    return (
        <>
            <SEO title={t('seo.title')} description={t('seo.desc')} />
            <SEOlinksA locale={locale} list={['us', 'ca']} pathname={'referral'} />
            <PageLayout hideFooter={isApp} hideHeader={isApp}>
                <ReferralProvider>
                    {['us', 'ca'].includes(locale) && <CountDown />}
                    <ShareCompoment />
                </ReferralProvider>
            </PageLayout>
        </>
    );
};

export default Referral;

// 以下两个方法不可删除，否则会重复触发 _app.js 中 getInitialProps 中的请求
export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
    const whiteLocaleList = ['us', 'ca'];
    if (!whiteLocaleList.includes(locale as string)) {
        return { notFound: true };
    }
    return {
        props: {},
    };
};
